export default function updateCustomerTypingState(typingState) {
  return (dispatch, getState, { messageGateway }) => {
    messageGateway.updateCustomerTypingState(typingState);
  };
}
